import React from 'react';
import { Contract, PaymentStatement, Subcontractor } from '../../../types';
import { KlSheet } from '../modal/KlSheet';

export interface MobileViewEPListSheetProps {
    open: boolean;
    onClose: () => void;
    contract: Contract;
    subcontractor?: Subcontractor | null;
    paymentStatements: PaymentStatement[];
    onSelectEP?: (ep: PaymentStatement) => void;
}

export const MobileViewEPListSheet: React.FC<MobileViewEPListSheetProps> = ({
    open,
    onClose,
    contract,
    subcontractor,
    paymentStatements = [],
    onSelectEP
}) => {
    const relatedEPs = paymentStatements.filter(ep => ep.contractId === contract.id);

    return (
        <KlSheet
            height="fixed"
            fixedHeight={420}
            open={open}
            onClose={onClose}
            title="Estados de pago"
            footer={
                <button
                    type="button"
                    onClick={onClose}
                    className="w-full h-11 rounded-[12px] font-bold text-sm border border-[#BFDBFE] dark:border-blue-900/60 bg-[#EFF6FF] dark:bg-blue-950/60 text-[#1D4ED8] dark:text-blue-300 active:scale-[0.98] transition-transform"
                >
                    Cerrar
                </button>
            }
        >
            <div className="flex flex-col gap-2.5 -mx-1 py-1">
                {/* Subtítulo contextual del contratista */}
                <div className="text-[12px] text-[#64748B] dark:text-slate-400 font-medium px-1">
                    {subcontractor?.razonSocial || 'Contratista'} · <span className="font-mono">{contract.id}</span>
                </div>

                {/* Lista de tarjetas de Estados de Pago (11-ver-estados-de-pago.html) */}
                {relatedEPs.length === 0 ? (
                    <div className="text-center text-[#64748B] dark:text-slate-400 text-[13px] italic py-8">
                        No se han generado Estados de Pago para este contrato.
                    </div>
                ) : (
                    <div className="space-y-2 max-h-[260px] overflow-y-auto">
                        {relatedEPs.map((ep, idx) => {
                            const epTotal = (ep.items || []).reduce((acc, item) => acc + (item.paidAmount || item.totalValue || 0), 0);
                            const formattedDate = (ep as any).date || ep.endDate || ep.startDate || ep.period || 'Sin fecha';

                            return (
                                <div
                                    key={ep.id || idx}
                                    onClick={() => onSelectEP && onSelectEP(ep)}
                                    className="flex items-center gap-2.5 p-3 bg-white dark:bg-slate-800 rounded-[14px] border border-slate-100 dark:border-slate-700/60 shadow-xs cursor-pointer active:bg-blue-50/50 dark:active:bg-blue-950/40 transition-colors"
                                >
                                    <i className="w-2 h-2 rounded-full bg-[#2563EB] shrink-0" />
                                    <div className="flex-1 min-w-0 pr-1">
                                        <b className="text-[14px] text-[#0F172A] dark:text-slate-100 block truncate">
                                            Estado de pago #{idx + 1}
                                        </b>
                                        <div className="text-[12px] text-[#64748B] dark:text-slate-400 mt-0.5 truncate">
                                            {formattedDate} · Monto: <span className="font-mono font-bold">${epTotal.toLocaleString('es-CL')}</span>
                                        </div>
                                    </div>
                                    <svg
                                        className="w-[18px] h-[18px] text-[#94A3B8] shrink-0"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <path d="m9 18 6-6-6-6" />
                                    </svg>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </KlSheet>
    );
};
